module.exports = __webpack_public_path__ + "static/media/apartment11.4b6e25a1.jpg";